/**
 * useDebouncedValue — generic debounce hook for input values.
 *
 * Cél: server-side search input throttle-olása (felhasználó gépel "Honda Eu" →
 * a backend csak 250ms után kapja meg a stabilizált értéket).
 *
 * Inline 15-soros utility a 105-8a-hoz (E-105). NEM kell `use-debounce` npm dep.
 */
import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
